import { ProcessAction, } from '@signage-player/contracts';
import { isObserverInstance } from './instanceId';
/**
 * Browser stub. RESTART and REBOOT map to page reloads via LifecycleInterface.
 * All other actions warn-log and clear the server-side action so the device
 * doesn't loop on it.
 */
export class ProcessActionService {
    constructor(logger, lifecycle, serverApiService) {
        this.logger = logger;
        this.lifecycle = lifecycle;
        this.serverApiService = serverApiService;
    }
    async handleNewDeviceData(device) {
        const observer = isObserverInstance();
        const all = [...device.displays];
        if (device.primary_display && !all.find(d => d.id === device.primary_display?.id)) {
            all.push(device.primary_display);
        }
        for (const display of all) {
            if (display.action) {
                if (observer) {
                    this.logger.notice(`[ProcessActionService] Observer mode — deferring action '${display.action}' to the Electron device`, { action: display.action });
                    return;
                }
                await this.processAction(display.action);
                break;
            }
        }
    }
    async processAction(action) {
        try {
            await this.clearAction();
            switch (action) {
                case ProcessAction.RESTART:
                    await this.lifecycle.relaunch();
                    return true;
                case ProcessAction.REBOOT:
                    await this.lifecycle.reboot();
                    return true;
                case ProcessAction.SHUTDOWN:
                case ProcessAction.POWER_ON:
                case ProcessAction.INSTALL_ANYDESK:
                case ProcessAction.TAKE_SCREENSHOT:
                case ProcessAction.TAKE_SCREENSHOT_DEVTOOLS:
                case ProcessAction.SEND_TELEMETRY:
                case ProcessAction.RUN_MIGRATION:
                    this.logger.warning(`[ProcessActionService] Action '${action}' is not supported in the web port`);
                    return true;
                default:
                    this.logger.warning(`[ProcessActionService] Unknown action: ${action}`);
                    return false;
            }
        }
        catch (error) {
            this.logger.error('[ProcessActionService] Error processing action', { error: error, action });
            await this.clearAction();
            return false;
        }
    }
    async clearAction() {
        try {
            await this.serverApiService.updateDevice({ display_action: null });
        }
        catch (error) {
            this.logger.warning('[ProcessActionService] Error clearing action', { error: error });
        }
    }
}
export default ProcessActionService;
//# sourceMappingURL=ProcessActionService.js.map